import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const LANGUAGES = {
  EN: 'en',
  ES: 'es'
};

export const LanguageProvider = ({ children }) => {
  // Try to get language from localStorage, fallback to browser language, then default to English
  const getInitialLanguage = () => {
    const saved = localStorage.getItem('bha-language');
    if (saved && Object.values(LANGUAGES).includes(saved)) {
      return saved;
    }
    
    // Check browser language
    const browserLang = navigator.language?.toLowerCase();
    if (browserLang?.startsWith('es')) {
      return LANGUAGES.ES;
    }
    
    return LANGUAGES.EN;
  };

  const [language, setLanguageState] = useState(getInitialLanguage);

  const setLanguage = (lang) => {
    setLanguageState(lang);
    localStorage.setItem('bha-language', lang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
